/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NamedNodeMap } from './namedNodeMap';
import { Element } from './element';
import { Node } from './node';
import { NodeList } from './nodeList';
import { Document } from './document';
import { TypeInfo } from './typeInfo';


export interface Attr { 
    name?: string;
    value?: string;
    specified?: boolean;
    ownerElement?: Element;
    schemaTypeInfo?: TypeInfo;
    id?: boolean;
    attributes?: NamedNodeMap;
    namespaceURI?: string;
    nodeType?: number;
    localName?: string;
    nodeName?: string;
    nodeValue?: string;
    firstChild?: Node;
    previousSibling?: Node;
    ownerDocument?: Document;
    baseURI?: string;
    textContent?: string;
    childNodes?: NodeList;
    nextSibling?: Node;
    parentNode?: Node;
    lastChild?: Node;
    prefix?: string;
}

